export const FORM_VERSION = "A1-1.0-stage1";

export const openingBlock = [
  "Your ratings help the project decide how much each indicator should count in the Water Security Index.",
  "About 20–30 minutes; every indicator is optional — leave it blank if you have no basis to judge.",
  "The assigned weight will quantify a variable’s relative importance and influence on the overall Water Security Index outcome.",
];

export const organisationTypes = [
  "Municipality",
  "Water board",
  "National/provincial government",
  "Academia",
  "NGO/CBO",
  "Private sector",
  "Reference group",
  "Independent / Other",
];

export const yearsExperienceBands = [
  "<3",
  "3–5",
  "6–10",
  "11–20",
  ">20",
  "Prefer not to say",
];

export const configuredAreas = [
  { code: "ZA-NATIONAL", label: "National / cross-municipality" },
  { code: "EKU", label: "City of Ekurhuleni" },
  { code: "JHB", label: "City of Johannesburg" },
];

export const weightingBasisPointers = [
  {
    title: "Direct relationship to water security",
    detail:
      "Give more weight where the indicator has a clear causal or decision-relevant relationship to water availability, quality, access, reliability or resilience.",
  },
  {
    title: "Reliable and available evidence",
    detail:
      "Consider whether suitable data can be collected consistently, is current enough, and can be checked across municipalities or settlements.",
  },
  {
    title: "Sensitivity and discriminating power",
    detail:
      "Ask whether a meaningful change in the indicator would reveal a meaningful change in water security or distinguish places with different conditions.",
  },
  {
    title: "Avoid double-counting",
    detail:
      "Reduce weight where the same effect is already strongly represented by another indicator, unless the two measures add distinct information.",
  },
  {
    title: "Comparability over place and time",
    detail:
      "Prefer indicators with definitions, units and collection methods that support fair comparison between areas and repeated assessment over time.",
  },
  {
    title: "Actionability and governance value",
    detail:
      "Consider whether the indicator helps identify a practical intervention, management priority or accountable decision.",
  },
  {
    title: "Local context, equity and unintended effects",
    detail:
      "Apply professional knowledge of the area, including vulnerable groups and local conditions that may make an indicator more or less important.",
  },
];

export const indicatorExplanations: Record<string, string> = {
  "D1-I07":
    "Water balance compares the water entering or available to an area with water use and losses. A more positive balance means available supply more comfortably meets demand; a negative or declining balance signals greater water-security pressure.",
};
